import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchStatusesService } from '../../../components/Support/services/masterData';

import type { StatusObj } from './support.types';
import { createInitialMasterState } from './helpers';

export const fetchStatusesAsyncThunk = createAsyncThunk(
  'supportStatuses/fetchStatuses',
  async (_, { rejectWithValue }) => {
    const { status, statusCode, data, message } = await fetchStatusesService();
    if (!status || statusCode !== 200 || !data)
      return rejectWithValue(message ?? 'Internal Server Error');
    return data;
  }
);

export const statusesSlice = createSlice({
  name: 'supportStatuses',
  initialState: createInitialMasterState<StatusObj>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchStatusesAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchStatusesAsyncThunk.fulfilled,
        (state, action: PayloadAction<StatusObj[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchStatusesAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = statusesSlice.actions;
export default statusesSlice.reducer;
